module.exports = __webpack_public_path__ + "img/icon-download.d528533a.svg";